import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';

const ProtectedRoute = ({ children, allowedTypes, allowedPermisos }) => {
  const { currentUser, loadingUser } = useContext(UserContext);

  if (loadingUser) {
    return (
      <div className="content-wrapper">
        <p>Cargando sesión...</p>
      </div>
    );
  }
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  const hasAllowedTipo = !allowedTypes || allowedTypes.includes(currentUser.tipo);
  const hasAllowedPermiso = !allowedPermisos || allowedPermisos.includes(currentUser.permiso);

  if (!hasAllowedTipo || !hasAllowedPermiso) {
    if (currentUser.tipo === 'empresa'|| currentUser.tipo === 'paciente') {
      return <Navigate to="/perfil" replace />;
    }
    return <Navigate to="/pacientes" replace />;
  }

  return children;
};

export default ProtectedRoute;